<template>
  <div class="payment">

    <mt-cell v-if="isShow === '2'" title="您有未支付的订单如下:" class="tip"></mt-cell>

    <mt-cell v-if="isShow === '1'" title="业主信息" :value="owner_str" @click.native="selectRoom()" >{{owner_str}}<button class="sub-change" @click="selectRoom()">切换房间></button></mt-cell>
    <mt-cell v-else-if="isShow === '2'" title="业主信息" :value="owner_str" @click.native="selectRoom()" >{{owner_str}}<button class="sub-change" @click="selectRoom()">切换房间></button></mt-cell>
    <mt-cell v-else-if="isShow === '3'" title="业主信息" :value="owner_str" @click.native="selectRoom()" >{{owner_str}}<button class="sub-change" @click="selectRoom()">切换房间></button></mt-cell>

    <mt-cell v-if="isShow === '1' && !isYatai" title="计费周期" class="time" @click.native="dateControl">
        <span>{{start_time}}到</span>
        <span>{{end_time}}</span>
    </mt-cell>
    <mt-cell v-else-if="isShow === '1' && isYatai" title="核算截止日期">
        <span>{{end_time}}</span>
    </mt-cell>
    <span style="font-size: 15px;color: red;margin-left: 10px;">{{noticeMsg}}</span>
    <h3 v-if="isShow === '1'">缴费明细</h3>
    <h3 v-else-if="isShow === '2'">缴费明细</h3>

    <div v-if="isShow === '1'" v-for="(list,index) in detail_array">
      <a class="mint-cell money maintenance"><!----> 
        <div class="mint-cell-left"></div> 
        <div class="mint-cell-wrapper">
          <div class="mint-cell-title"><!----> 
            <span class="mint-cell-text">{{list.fee_name}}</span> 
            <span v-if="list.use_prestore > 0" class="mint-cell-label">（预存抵扣：{{list.use_prestore}}元，剩余：{{list.left_prestore}}元）</span>
            <span style="padding-bottom: 10px;" class="mint-cell-label">{{list.time_info}}</span>
          </div> 
          <div class="mint-cell-value">
            <span>￥{{list.price}}</span>
          </div> <!----></div> 
        <div class="mint-cell-right"></div>
      </a>
        <!-- <mt-cell :title="list.fee_name" :label="list.time_info" class="money maintenance">
            <span>￥{{list.price}}</span>
        </mt-cell> -->
    </div>

    <div v-if="isShow === '2'" v-for="(list,index) in detail_array">
      <a class="mint-cell money maintenance"><!----> 
        <div class="mint-cell-left"></div> 
        <div class="mint-cell-wrapper">
          <div class="mint-cell-title"><!----> 
            <span class="mint-cell-text">{{list.fee_name}}</span> 
            <span v-if="list.use_prestore > 0" class="mint-cell-label">（预存抵扣：{{list.use_prestore}}元，剩余：{{list.left_prestore}}元）</span>
            <span style="padding-bottom: 10px;" class="mint-cell-label">{{list.time_info}}</span>
          </div> 
          <div class="mint-cell-value">
            <span>￥{{list.price}}</span>
          </div> <!----></div> 
        <div class="mint-cell-right"></div>
      </a>
        <!-- <mt-cell :title="list.fee_name" :label="list.time_info" class="money maintenance">
            <span>￥{{list.price}}</span>
        </mt-cell> -->
    </div>
    <mt-cell v-if="isShow === '1'" title="总金额" class="money H33">
        <span>￥{{all_total_fee}}</span>
    </mt-cell>
    <!-- <mt-cell v-if="isShow === '1'" class="H33 currencies">
        <p slot="title">
            物业币
            <span class="count">{{property_gold_money}}</span>
            <i>?</i>
        </p>
        <span></span>
                      <input v-if="property_gold_money === '0.00'" disabled  placeholder="0物业币"  type="text">
                      <input v-else v-model="property_money" type="text" >       
    </mt-cell>
    <mt-cell v-if="isShow === '2' && cost_property_fee > 0" class="H33 currencies">
        <p slot="title">
            物业币抵扣
        </p>
                      ￥{{cost_property_fee}}       
    </mt-cell> -->

    <mt-cell v-if="isShow === '1'" title="应付" class="money H33">
        <span>￥{{real_money}}</span>
    </mt-cell>

    <mt-cell v-else-if="isShow === '2'" title="应付" class="money H33">
        <span>￥{{real_money}}</span>
    </mt-cell>

    <div class="handle-btns">
        <button v-if="isShow === '1'" class="sub" @click="subOrder()">提交</button>
        <button v-else-if="isShow === '2'" class="sub" @click="ToPay()" >继续支付</button>
        <button v-else-if="isShow ==='3'" class="contract" style="min-height: 40px;height: auto;line-height: initial;">{{error_info}}</button>
        <!-- <button v-if="isShow==='1'" class="contact" @click="contractProperty()">联系物业</button> -->
        <a v-if="isShow==='1'" class="contact a-btn" :href="property_tel" >联系物业</a>
        <button v-else-if="isShow==='2'" class="contact" @click="delOrder()">取消订单</button>
        <!-- <button v-else-if="isShow==='3'" class="contact" @click="contractProperty()">联系物业</button> -->
        <a v-else-if="isShow==='3'" class="contact a-btn" :href="property_tel" >联系物业</a>
        <p class="handle-tips" style="color: #ffb52a;" v-if="total_fee_water > 0">当前房间存在{{total_fee_water}}元的二次供水费未缴纳，请您到高新物业财务进行缴纳</p>
        <p class="handle-tips" style="color: red;" v-if="fee_token == 'cc_gxwy_yzmc'">缴费后如需发票请于缴费七日后年底前到物业财务开具发票，过期将无法开票</p>
        <p class="handle-tips">温馨提示：物业费订单提交后，请您在45分钟之内支付。如在规定时间内尚未支付，请重新提交哦。</p>
    </div>

    <!-- 选择缴费日期组件 -->
    <choosedate ref="datecontroller" :room-id="room_id" :user-id="userId" :start-time="start_time" :v-token="v_token" :fee-token="fee_token" v-on:themonth="comemonth"></choosedate>

    <mt-popup v-model="popupVisible" class="">
        <h4>选择要缴费的房间</h4>
        <!-- <div class="communities">
            <div class="commu-item" :class="{active: chosenCur == index}" v-for="(item, index) in communities" @click = "changeRoomInfo(item.room_id, index)">
                {{item.name}}
            </div>
        </div> -->
        <div class="communities" ref="communities-wrapper">
            <ul>
                <li class="commu-item" :class="{active: chosenCur == index}" v-for="(item, index) in communities" @click = "changeRoomInfo(item.room_id, index)">
                    {{item.name}}
                </li>
            </ul>
        </div>
        <button class="add-home" @click="toMyHouse()" style="width: 50%;left: 0;border-radius: 0;">管理房屋</button>
        <button class="add-home" @click="addHouse()" style="width: 50%;right: 0;border-radius: 0;background-color: #de9913;">添加房屋</button>
    </mt-popup>

  </div>
</template>
<script>
import ChooseDate from '@/components/ChooseDate' //缴费月份
import {MessageBox} from 'mint-ui';
import BScroll from 'better-scroll';
const wx = require('weixin-js-sdk');
export default {
  components: {
      choosedate: ChooseDate
  },
  data () {
    return {
        communities: [], // 小区列表
        owner: '1栋-1单元-101', // 供计算属性使用
        wx_config:'',
        start_time:'0000-00-00',
        end_time:'0000-00-00',
        detail_array:[],
        all_total_fee:0.00,
        property_fee:0,
        property_gold_money:0.00,//物业币
        owner_str:'',//业主信息
        v_token:'',   //常住房间所在小区token
        room_id:0,
        s_id_str:'',
        property_money:'',
        real_money:0.00,
        total_fee_water:0,
        popupVisible:false,
        isShow:'1',//1:未提交订单 2:已提交订单可直接付款 3：订单信息有误
        orderId:0,
        userId:'',
        error_info:'',
        noticeMsg:'',
        chosenCur: 0, // 选中的业主
        orderParams:{},
        fee_token:'',    //所选房间所在小区token
        isYatai:0,
        cost_property_fee:0,
        property_tel:'',
    }
  },
  watch:{
      popupVisible (val) {
          if(!val){
              document.body.style.position = 'static';
          }
      },
     property_money: function(val){
          val = Number(val);
          if(val >= this.property_fee){
             this.$toast({
                message:'使用的物业币不能大于或等于物业费',
                position:'middle',
                duration:'2000'
             });
             this.property_money = '';
            // return false;
          }

          if(val > this.property_gold_money){
             this.$toast({
                message:'物业币金额不能大于现有物业币金额',
                position:'middle',
                duration:'2000'
             })
             this.property_money = '';
          }

          this.real_money = Number(this.all_total_fee) - val;
    }
  },
  mounted() {
    window.addEventListener('scroll', this.menu)
  },  
  created(){
       this.userId = this.$route.query.userId;
       this.getBindRoom(this.userId);
       this.$nextTick(() => {
        this._initScroll();
       });
  },
  methods:{
    _initScroll () {
      this.menuScroll = new BScroll(this.$refs['communities-wrapper'], {
        click: true
      });
    },
    delOrder(){
        this.axios.delete('/jmobile/PropertyFeeHistory/delOrder/order_id/'+this.orderId).then((res)=>{
            if(res.data.status == '1'){
               this.$toast({
                 message:'订单删除成功',
                 position:'bottom',
                 duration:'2000'
               });
               location.reload();
            }else{
              this.$toast({
                 messsage:res.data.info,
                 position:'bottom',
                 duration:'2000'
              });
            }
        }).catch((res)=>{
            this.$toast({
               message:'网络错误',
               position:'bottom',
               duration:'2000'
            })
        });
    },

    comemonth (val) {
        this.getData(val.end_time);
        this.end_time = this.formatDate(val.end_time);

        //localStorage.setItem('endTime',val.end_time);
    },
    
    toMyHouse(){
        this.$router.push({name: 'MyHouse', query: {token:this.$route.query.token,userId:this.userId,property_token:this.$route.query.property_token,city_id:this.$route.query.city_id,jump_page:'Payment'}});
    },

    getBindRoom(userId){
        this.$indicator.open();
        let data = JSON.stringify({'user_id':userId});
        this.axios.get('/jmobile/PropertyFee/now_room/json/'+data).then((res)=>{
            this.$indicator.close();
            if(res.data.status == '1'){
                this.room_id = res.data.data.room_id;
                this.v_token = res.data.data.token;
                this.fee_token = res.data.data.token;
                
                //指定房间跳过来的
                if(this.$route.query.room_id && this.$route.query.room_id != 'undefined' && this.$route.query.fee_token && this.$route.query.fee_token != 'undefined'){
                    this.room_id = this.$route.query.room_id;
                    this.fee_token = this.$route.query.fee_token;
                }
                this.getEndTime();
            }else{
                // MessageBox({
                //    title:'提示',
                //    message:'暂没有绑定的房屋,点击确定去绑定房屋',
                // }).then(action=>{
                // });

                //跳我绑定的房间列表
                this.$router.push({name: 'MyHouse', query: {token:this.$route.query.token,userId:this.userId,property_token:this.$route.query.property_token,city_id:this.$route.query.city_id,jump_page:'Payment'}});

            }
        }).catch((response)=>{
            this.$toast({
              message:'网络错误',
              position:'bottom',
              duration:'2000'
            });
        });
    },
    getEndTime(){
        this.$indicator.open();
        // let url = '/jmobile/WxApi/index/room_id/'+this.room_id+'/token/'+this.v_token+'/user_id/'+localStorage.getItem('userId')+'/is_share/true';
         
        let url = '/jmobile/WxApi/index/room_id/'+this.room_id+'/token/'+this.v_token+'/fee_token/'+this.fee_token+'/user_id/'+this.userId+'/is_share/true';
         this.axios.get(url).then((res)=>{
             this.$indicator.close();
             if(res.data.status == '1'){

                //判断该室是否可以交费，如果可以则继续否则 失效
                // if(typeof(res.data.data.error_info) != 'undefined'){
                //     this.error_info = res.data.data.error_info;
                //     this.isShow = '3';
                //     this.owner_str = '';
                // }else{
                    //是否已经提交订单
                    if(res.data.data.is_paid){
                      //已经提交
                      this.getPaidInfo(res.data.data);
                      // this.isShow = '2';
                      this.orderParams = res.data.data;
                    }else{
                      //未提交
                      this.getData(res.data.data.end_time);
                      this.isShow = '1';
                    }
                // }

                   
                
             }else{
                this.$toast({
                    message:res.data.info,
                    position:'bottom',
                    duration:'3000'
                })
             }
         }).catch((response)=>{
             this.$toast({
                message:'网络错误',
                postion:'bottom',
                duration:'3000'
             })
         });
    },
    getData(end_time){
         
         this.$indicator.open();
         //let url = '/jmobile/WxApi/index/room_id/'+this.room_id+'/token/'+this.v_token+'/user_id/'+localStorage.getItem('userId')+'/end_time/'+end_time+'/is_share/true';
         let url = '/jmobile/WxApi/index/room_id/'+this.room_id+'/token/'+this.v_token+'/fee_token/'+this.fee_token+'/user_id/'+this.userId+'/end_time/'+end_time+'/is_share/true';

         this.axios.get(url).then((res)=>{
             this.$indicator.close();

                console.log(res)
             if(res.data.status == '1'){
                //判断该室是否可以交费，如果可以则继续否则 失效
                if(typeof(res.data.data.error_info) != 'undefined'){
                    this.error_info = res.data.data.error_info;
                    this.property_tel = 'tel:' + res.data.data.village_info.property_tel;
                    this.isShow = '3';
                    this.owner_str = res.data.data.owner_str;
                }else{  
                  //是否已经提交订单
                  if(res.data.data.is_paid){
                        this.getPaidInfo(res.data.data);
                        // this.isShow = '2';
                  }else{
                       
                         this.start_time = res.data.data.start_time_info;
                         this.end_time = res.data.data.end_time_info;
                         this.detail_array = res.data.data.detail_array;
                         this.all_total_fee = res.data.data.all_total_fee;
                         this.property_fee = res.data.data.property_fee;
                         this.real_money = res.data.data.all_total_fee;
                         this.total_fee_water = res.data.data.total_fee_water;
                         this.property_gold_money = res.data.data.property_gold_money;
                         this.owner_str = res.data.data.owner_str;
                         this.s_id_str = res.data.data.s_id_str;
                         this.noticeMsg = res.data.data.notice_msg;
                         this.isYatai = res.data.data.is_yatai?res.data.data.is_yatai:0;
                         this.property_tel = 'tel:' + res.data.data.village_info.property_tel;
                         if(res.data.data.end_time_info){
                            this.end_time = res.data.data.end_time_info;
                         }else{
                            this.end_time = '选择时间';     
                         }
                  }
                }    
               
            }else{
                this.$toast({
                    message:res.data.info,
                    position:'bottom',
                    duration:'3000'
                });
             }
         }).catch((response)=>{
             this.$toast({
                message:'网络错误',
                postion:'bottom',
                duration:'3000'
             });
         });
    },
    getPaidInfo(data){//已经提交订单，获取订单详情
          let params = '';
          params = '/order_id/'+data.order_id+'/s_type/' + data.s_type +'/user_id/' + data.user_id + '/token/' + data.token;
          let url = '/jmobile/WxPropertyFeeHistory/detail';
          this.axios.get(url+params).then((res)=>{
               if(res.data.status == '1'){
                  this.isShow = '2';
                  this.detail_array = res.data.data.detail_array;
                  this.owner_str = res.data.data.owner_str;
                  this.real_money = res.data.data.real_money;
                  this.orderId = res.data.data.info.id;
                  this.cost_property_fee = res.data.data.info.cost_property_fee;
               }else{
                  this.$toast({
                      message:res.data.info,
                      position:'bottom',
                      duration:'2000'
                  });
               }
          }).catch((res)=>{
              this.$toast({
                 message:'网络错误',
                 position:'bottom',
                 duration:'2000'
              })
          });
    },
    // 唤醒choosedate组件的显示
    dateControl () {
        this.$refs.datecontroller.showDate();
    },
    subOrder(){
        let qs = require('querystring');
       // let url = '/jmobile/WxApi/createNewOrder/token/'+this.v_token+'//user_id/'+localStorage.getItem('userId');
        let url = '/jmobile/WxApi/createNewOrder/token/'+this.v_token+'/fee_token/'+this.fee_token+'/user_id/'+this.userId;
        let data = {'s_id_str':this.s_id_str,'real_money':this.all_total_fee,'mobile_pay_method':'1',r_fee:this.property_money,origin_p_fee:this.property_fee,room_id:this.room_id};
            data = qs.stringify(data); 
        this.axios.post(url,data).then((res)=>{
            if(res.data.status == '1'){
                this.orderId = res.data.data.order_id;
                if(res.data.data.is_free){
                    //0元订单
                    this.$router.push({'name':'SuccessPay',query:{'orderId':this.orderId}}); 
                }else{
                    this.$router.push({name:'ToPay',query:{'orderId':this.orderId,'userId':this.userId,'v_token':this.v_token,'s_type':'1'}});
                    //this.getPayConfig();  
                }  
            }else{
                this.$toast({
                    message:res.data.info,
                    position:'bottom',
                    duration:'2000'
                });
            }
        }).catch((response)=>{
                this.$toast({
                    message:'网络错误',
                    position:'bottom',
                    duration:'2000'
                })
        });
    },
    ToPay(){
  
      this.$router.push({name:'ToPay',query:{'orderId':this.orderParams.order_id,'userId':this.orderParams.user_id,'v_token':this.v_token,'s_type':this.orderParams.s_type}})
    },
    
    
    
    formatDate(now){
         let    date = new Date(now * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
         let    Y = date.getFullYear() + '-';
         let    M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
         let    D = date.getDate() + ' ';
                return Y+M+D;
    },
    selectRoom(){
        var json = JSON.stringify({'user_id':this.userId,'token':this.v_token});
        this.axios.get('/jmobile/PropertyFee/room_lists/json/'+json).then((res)=>{
          
           if(res.data.status == '1'){
              this.communities = res.data.data;
              this.communities.forEach((item,index)=>{
                  if(item.room_id == this.room_id) this.chosenCur = index;
              });
              document.getElementsByTagName('body')[0].style.position = 'fixed';
              this.popupVisible = true;
           }else{
              this.$toast({
                 message:res.data.info,
                 position:'bottom',
                 duration:'2000'
              });
           }
        }).catch((res)=>{
              this.$toast({
                 message:'网络错误',
                 position:'bottom',
                 duration:'2000'
              });
        });
    },
    changeRoomInfo(room_id,idx){
        this.chosenCur = idx;
        this.popupVisible = false;
        document.getElementsByTagName('body')[0].style.position = 'static';
        this.room_id = this.communities[this.chosenCur].room_id;
        this.fee_token = this.communities[this.chosenCur].token;
        this.property_money = '';
        this.cost_property_fee = 0;
        this.getEndTime();
    },
    contractProperty(){
       MessageBox.alert(this.property_tel,'提示');
    },


    // 添加我的房屋 注意: 该方法里的v_token指的是跳转后要显示的小区, token指的是级别,而非常住房间所在小区的token, 所以都不能取this.v_token(跟MyHouse里的addMyHouse方法相同,只是多了个jump参数,注意配套修改)
    addHouse(){
        let jump = 'Payment';  //从缴费页面添加房屋, 添加完以后调回缴费页面
        if(this.$route.query.city_id && this.$route.query.city_id != 'undefined'){    //城市级别
            this.$router.push({name: 'SearchCommunity', query: {token:this.$route.query.token,userId:this.$route.query.userId,property_token:this.$route.query.property_token,city_id:this.$route.query.city_id,jump:jump}});
        }
        else if(this.$route.query.property_token && this.$route.query.property_token != 'undefined'){     //物业级别
            let json={property_token:this.$route.query.property_token};
                json=JSON.stringify(json);

            this.axios.get('/jmobile/MyVillageRoom/getVillageByProperty/json/'+json).then((res)=>{
                 if(res.data.status == '1'){
                       this.$router.push({name: 'SelectCommunity', query: {v_token:res.data.data[0].v_token,token:this.$route.query.token,userId:this.$route.query.userId,property_token:this.$route.query.property_token,city_id:this.$route.query.city_id,jump:jump}})
                 }else{
                    this.$toast({
                        message:res.data.info,
                        position:'bottom',
                        duration:'2000'
                    });
                 }
            }).catch((res)=>{
                this.$toast({
                    message:'参数错误',
                    position:'bottom',
                    duration:'2000'
                })
            })
        }else{     //小区级别
            this.$router.push({name: 'SelectCommunity', query: {v_token:this.$route.query.token,token:this.$route.query.token,userId:this.$route.query.userId,property_token:this.$route.query.property_token,city_id:this.$route.query.city_id,jump:jump}});
        }
    },
    
  },
  computed: {
    // 业主信息
    ownerInfo () {
        return this.owner + ' *';
    }
  }
}
</script>
<style lang="less">
.payment{
    width: 100%;
    height: 100%;
    color: #000;
    background-color: #f8f8fa;
    line-height: 24px;
    .mint-cell{
        .mint-cell-wrapper{
            background-image: none;
        }
        &.time{
            margin-top: 10px;
            .mint-cell-value{
                color: #777;
                span{
                    &:last-child{
                        color: #ffb52a;
                    }
                }
            }
        }
        &.tip{
          margin-bottom:10px;
        }
        &.maintenance{
            min-height: 64px;
            .mint-cell-wrapper{
                span{
                    &:last-child{
                        margin-top: 15px;
                    }
                    &.mint-cell-text{
                        color: #626262;
                    }
                    &.mint-cell-label{
                        margin-top: 12px;
                        color: #b3b3b3;
                    }
                }
            }
        }
        &.money{
            .mint-cell-value{
                color: #ffb52a;
            }
        }
        &.H33{
            min-height: 33px;
        }
        &.currencies{
            .mint-cell-title{
                span{
                    margin: 0 7px;
                    padding: 3px 4px;
                    background-color: #ffaa0d;
                    color: #fff;
                    font-size: 14px;
                    border-top-left-radius: 47%;
                    border-bottom-left-radius: 48%;
                    border-bottom-right-radius: 30%;
                }
                i{
                    display: inline-block;
                    width: 20px;
                    height: 20px;
                    line-height: 20px;
                    text-align: center;
                    background: #c5c5c5;
                    color: #fff;
                    font-size: 14px;
                    font-style: normal;
                    border-radius: 50%;
                    font-weight: bold;
                }
            }
            .mint-cell-value{
                span{
                    display: inline-block;
                    width: 7px;
                    border-top: 1px solid #000;
                }
                input{
                    margin-left: 10px;
                    padding: 0 5px;
                    width: 55px;
                    height: 24px;
                    border: 1px solid #dcdcdc;
                    border-top-width: 3px;
                    border-radius: 3px;
                }
            }
        }
    }
    h3{
        padding: 10px 12px 13px;
        font-size: 16px;
        font-weight: normal;
    }
    .handle-btns{
        margin: 10px 0;
        padding: 0 20px;
        color: #000;
        button,
        a{
            display: block;
            width: 100%;
            height: 40px;
            line-height: 40px;
            text-align: center;
            border-radius: 10px;
            font-size: 15px;
            color: #fff;
            &.sub{
                background: #ffaf1c;
            }
            &.contract{
              background: #ffdd99;
            }
            &.contact{
                margin: 10px 0 22px;
                background: #c5c5c5;
            }
        }
        .handle-tips{
            font-size: 13px;
        }
    }
    .mint-popup{
        padding-bottom: 30px;
        width: 80%;
        min-height: 80%;
        border-radius: 10px;
        h4{
            position: absolute;
            top: 0;
            width: 100%;
            text-align: center;
            height: 50px;
            line-height: 50px;
            color: #999;
            font-weight: normal;
            border-bottom: 1px solid #ececec;
        }
        .communities{
            border-radius: 20px;
            position: absolute;
            top: 50px;
            bottom: 40px;
            width: 100%;
            overflow-y: scroll;
            -webkit-overflow-scrolling: touch;
            .commu-item{
                box-sizing: border-box;
                width: 100%;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                height: 50px;
                line-height: 50px;
                text-align: center;
                border-bottom: 1px solid #ececec;
                &.active{
                    color: #ffaf14;
                }
            }
        }
        .add-home{

        }
        button{
            position: absolute;
            bottom: 0;
            width: 100%;
            text-align: center;
            line-height: 40px;
            height: 40px;
            background: #ffaf14;
            color: #fff;
            font-size: 16px;
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;            
        }
    }
    .sub-change{
        margin: 10px 0 10px 10px;
        padding: 0 3px;
        color: #000;
        background: red;
        display: block;
        width: 70px;
        height: 25px;
        line-height: 25px;
        text-align: center;
        border-radius: 15px;
        font-size: 10x;
        color: #fff;
    }
}
</style>




// WEBPACK FOOTER //
// src/components/Payment.vue